<page-load-header *ngIf="!initialized"></page-load-header>

<div class="row mb-3">
  <div class="col-md-6">
    <div class="dropdown"><h3>My Live Events</h3></div>
  </div>
  <div class="col-md-6 text-right">
    <button class="btn btn-sm btn-admin-primary" type="button" tabindex="0" [routerLink]="['/account/live-events/schedule']">Schedule an Event</button>
  </div>
</div>
<div *ngIf="initialized">
  <div class="row no-gutters no-candidates" style="height: 300px" *ngIf="events && events.length == 0">
    <div class="col-sm-12 my-auto">
      <h1><i class="fas fa-empty-set"></i></h1>
      <h4>No Events listed yet.</h4>
      <p>Let's add one!</p>
      <a [routerLink]="['/account/live-events/schedule']" class="btn btn-instagram">Schedule an Event</a>
    </div>
  </div>

  <div class="card mb-2" *ngFor="let evnt of events">
    <div class="card-body p-4">
      <div class="media d-block d-sm-flex">
        <div class="media-body">
          <div class="media mb-2">
            <div class="media-body">
              <div class="row">
                <div class="col-md-10">
                  <h1 class="h5 mb-1">
                    <a [routerLink]="[evnt.id, 'edit']">{{ evnt.title }}</a>
                  </h1>

                  <div class="d-md-flex align-items-md-center">
                    <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
                      <h2 class="small text-secondary mb-0">Date</h2>
                      <small class="fas fa-calendar-alt text-secondary align-middle mr-1"></small>
                      <span class="align-middle">{{ evnt.startTime | date: 'short' }} </span>
                    </div>
                    <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
                      <h2 class="small text-secondary mb-0">Status</h2>
                      <span class="align-middle">
                        <span class="badge {{ evnt.courseEventStatus }}">{{ evnt.courseEventStatus | enumValue: CourseEventStatus:CourseEventStatusEnum }}</span>
                      </span>
                    </div>
                    <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
                      <h2 class="small text-secondary mb-0">Room</h2>
                      <span *ngIf="evnt.roomName" class="align-middle">{{ evnt.roomName }}</span>
                      <span *ngIf="!evnt.roomName" class="align-middle">N/A</span>
                    </div>
                    <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
                      <h2 class="small text-secondary mb-0">Registrants</h2>
                      <span class="align-middle">{{ evnt.purchaseCount }}</span>
                    </div>
                    <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
                      <h2 class="small text-secondary mb-0">Reservations</h2>
                      <span class="align-middle">{{ evnt.reservationCount }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="text-right">
                    <div class="position-relative d-inline-block text-right">
                      <div class="dropdown text-right">
                        <button class="btn btn-xs btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
                        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                          <!-- <a class="dropdown-item" [routerLink]="[event.id, 'edit']">Edit Details</a> -->
                          <a class="dropdown-item" [routerLink]="['/live-events/', evnt.id, 'presenter-dashboard']">Enter Live Dashboard</a>
                          <a class="dropdown-item" [routerLink]="['/live-events/', evnt.id, 'presenterview']">SideCar Hybrid Tools</a>
                          <a class="dropdown-item" [routerLink]="[evnt.id, 'edit']">Edit Event</a>
                          <div class="dropdown-divider"></div>
                          <a class="dropdown-item" href="/download-qrcode?eventId={{ evnt.id }}&inOut=In">Check In QR Code</a>
                          <a class="dropdown-item" href="/download-qrcode?eventId={{ evnt.id }}&inOut=Out">Check Out QR Code</a>
                          <a class="dropdown-item" href="javascript:void(0)" (click)="editCEUAssessment(evnt)">Edit CEU Assessment</a>
                          <div class="dropdown-divider"></div>
                          <a class="dropdown-item" href="javascript:void(0)" (click)="export(evnt)">Download Presenter Data</a>

                          <!-- <a class="dropdown-item" [routerLink]="['.', poster.id, 'dashboard']">Poster Dashboard</a> -->
                          <!-- <div class="dropdown-divider"></div> -->
                          <!-- <a class="dropdown-item" href="#">Export Attendees</a> -->
                          <!-- <a class="dropdown-item" href="#">Export Chat History</a> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>




</div>
